"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const dist_1 = require("../../../fs/dist");
exports.toolDef = {
    name: 'loom_get_context_prefs',
    description: 'Read the persisted sidebar CONTEXT overrides for a target doc from .loom/context-prefs.json. Returns { docUlid, entry: { include, exclude } } (empty arrays when none are set).',
    inputSchema: {
        type: 'object',
        properties: {
            doc_ulid: { type: 'string', description: 'Target document ULID' },
        },
        required: ['doc_ulid'],
    },
};
async function handle(root, args) {
    const docUlid = args['doc_ulid'];
    if (!docUlid)
        throw new Error('doc_ulid is required');
    const entry = await (0, dist_1.readContextPrefsEntry)(root, docUlid);
    return { content: [{ type: 'text', text: JSON.stringify({ docUlid, entry }) }] };
}
